import { FaFacebookF, FaXTwitter, FaWhatsapp, FaPinterestP, FaTelegram, FaInstagram, FaTiktok, FaLinkedinIn } from "react-icons/fa6";

const enc = encodeURIComponent;

export const shareLink = (path, ref) => `${window.location.origin}${path}?ref=${ref}`;

export const parseSharePath = (path) => {
  const m = path.match(/^\/(deal|coupon|trip|guides|reviews)\/([^/?#]+)/);
  if (!m) return null;
  return { kind: { guides: "guide", reviews: "review" }[m[1]] || m[1], key: m[2] };
};

export const fullPost = (c, link) => [c.caption, link, (c.hashtags || []).join(" ")].filter(Boolean).join("\n\n");

// visual: header tint + button colour; post(): url to open after the caption is copied
export const PLATFORMS = [
  { id: "facebook", label: "Facebook", Icon: FaFacebookF, color: "#1877F2", tint: "bg-[#EEF4FF] border-[#C9DBFB]",
    post: (c, link) => `https://www.facebook.com/sharer/sharer.php?u=${enc(link)}`, pasteHint: true },
  { id: "instagram", label: "Instagram", Icon: FaInstagram, color: "linear-gradient(90deg,#F58529,#DD2A7B,#8134AF)", tint: "bg-[#FFF0F6] border-[#F8C8DC]",
    post: () => "https://www.instagram.com/", needsCard: true, story: true },
  { id: "x", label: "X (Twitter)", Icon: FaXTwitter, color: "#000000", tint: "bg-neutral-50 border-neutral-200",
    post: (c, link) => `https://twitter.com/intent/tweet?text=${enc(`${c.caption} ${(c.hashtags || []).join(" ")}`)}&url=${enc(link)}` },
  { id: "pinterest", label: "Pinterest", Icon: FaPinterestP, color: "#E60023", tint: "bg-[#FFF0F0] border-[#F6C6C9]",
    post: (c, link, card) => `https://pinterest.com/pin/create/button/?url=${enc(link)}&media=${enc(card)}&description=${enc(`${c.caption} ${(c.hashtags || []).join(" ")}`)}` },
  { id: "whatsapp", label: "WhatsApp", Icon: FaWhatsapp, color: "#25D366", tint: "bg-[#EFFBF3] border-[#BDEBCB]",
    post: (c, link) => `https://api.whatsapp.com/send?text=${enc(fullPost(c, link))}` },
  { id: "telegram", label: "Telegram", Icon: FaTelegram, color: "#229ED9", tint: "bg-[#EEF8FD] border-[#C2E5F5]",
    post: (c, link) => `https://t.me/share/url?url=${enc(link)}&text=${enc(`${c.caption}\n\n${(c.hashtags || []).join(" ")}`)}` },
  { id: "tiktok", label: "TikTok", Icon: FaTiktok, color: "#111111", tint: "bg-[#F2FEFE] border-[#BFEFEF]",
    post: () => "https://www.tiktok.com/upload", needsCard: true, story: true },
  { id: "linkedin", label: "LinkedIn", Icon: FaLinkedinIn, color: "#0A66C2", tint: "bg-[#EEF5FC] border-[#C3DAF2]",
    post: (c, link) => `https://www.linkedin.com/sharing/share-offsite/?url=${enc(link)}`, pasteHint: true },
];

export const TONES = [
  { id: "engaging", label: "Engaging" },
  { id: "professional", label: "Professional" },
  { id: "urgent", label: "Urgent Sale" },
  { id: "casual", label: "Casual" },
];

export const isTouch = () => typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches && !!navigator.share;
